import type { ReactNode } from "react";

export default function FundamentalsLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      {children}
    </main>
  );
}
